import { Component, OnInit, ElementRef, Input } from '@angular/core';
import { WindowService } from '../window.service';

@Component({
  selector: 'google-maps',
  template: '<div class="map"></div>',
  styleUrls: ['./maps.component.scss'],
})
export class MapsComponent implements OnInit {

  private domElement;
  private google;
  @Input() height;
  @Input() center;
  @Input() locations = [];

  constructor(element: ElementRef, private windowService: WindowService) {
    this.domElement = element.nativeElement;
    this.google = windowService.nativeWindow.google;
  }

  createMap() {
    const mapOptions = {
      zoom: this.center.zoom || 4,
      center: this.mapCenter(),
      mapTypeId: this.google.maps.MapTypeId.ROADMAP,
    };
    return new this.google.maps.Map(this.domElement, mapOptions);
  }

  mapCenter() {
    return new this.google.maps.LatLng(
      this.center.lat,
      this.center.lng,
    );
  }

  ngOnInit() {
    this.domElement.style.display = 'block';
    this.domElement.style.height = (this.height || 350) + 'px';
    const map = this.createMap();
    const infowindow = new this.google.maps.InfoWindow();

    for (let i = 0; i < this.locations.length; i++) {
      const location = this.locations[i];
      const marker = new this.google.maps.Marker({
        position: new this.google.maps.LatLng(location[1], location[2]),
        map,
      });

      // tslint:disable-next-line:no-shadowed-variable
      this.google.maps.event.addListener(marker, 'click', (function(marker, i) {
        return function() {
          infowindow.setContent(location[0]);
          infowindow.open(map, marker);
        };
      })(marker, i));
    }
  }

}
